(function () {
  'use strict';

  window.__melindasA11yCookieHardeningVersion = '2026-10-26-ea-focus-return';

  var BANNER_SELECTORS = [
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    '.shopify-privacy-banner',
    '[id*="cookie-banner"]',
    '[class*="cookie-banner"]'
  ].join(',');
  var INTERACTIVE_SELECTOR = [
    'button',
    'a[href]',
    'input',
    'select',
    'textarea',
    '[role="button"]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function lowerText(value) {
    return cleanText(value).toLowerCase();
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isVisuallyHidden(element) {
    if (!element) return true;
    var className = typeof element.className === 'string' ? element.className : '';
    if (/\b(sr-only|visually-hidden|screen-reader)\b/i.test(className)) return true;
    var style = window.getComputedStyle(element);
    if (style.clip !== 'auto' || style.clipPath !== 'none') return true;
    var rect = element.getBoundingClientRect();
    return rect.width <= 2 && rect.height <= 2;
  }

  function ensureId(element, fallback) {
    if (!element.id) {
      element.id = fallback + '-' + Math.random().toString(36).slice(2, 8);
    }
    return element.id;
  }

  function getBanner() {
    var preferred = document.getElementById('shopify-pc__banner');
    if (preferred) return preferred;

    var candidates = document.querySelectorAll(BANNER_SELECTORS);
    for (var i = 0; i < candidates.length; i += 1) {
      if (candidates[i].querySelector && candidates[i].querySelector(INTERACTIVE_SELECTOR)) {
        return candidates[i];
      }
    }
    return null;
  }

  function ensureAssistiveLandmarks() {
    var body = document.body;
    if (!body) return;

    var startScript = document.getElementById('usntA42start');
    if (startScript) {
      startScript.setAttribute('data-a42-container', 'usableNetAssistive');
    }

    var container = document.getElementById('usableNetAssistive');
    if (!container) {
      container = document.createElement('div');
      container.id = 'usableNetAssistive';
      container.setAttribute('role', 'complementary');
      container.setAttribute('aria-label', 'Accessibility options');
    }

    var skipLink = document.querySelector('a.skip-to-content[href="#MainContent"]');
    if (skipLink) {
      skipLink.textContent = 'Skip to main content';
      if (container.parentNode !== body || container.nextSibling !== skipLink) {
        body.insertBefore(container, skipLink);
      }
    } else if (container.parentNode !== body) {
      body.insertBefore(container, body.firstChild);
    }

    var main = document.getElementById('MainContent');
    if (main) {
      main.setAttribute('role', 'main');
    }
  }

  function installHardeningStyles() {
    var style = document.getElementById('a11y-cookie-banner-hardening-styles');
    if (style && style.getAttribute('data-a11y-hardening-version') === '2026-10-26-ea-focus-return') return;

    if (!style) {
      style = document.createElement('style');
      style.id = 'a11y-cookie-banner-hardening-styles';
    }

    style.id = 'a11y-cookie-banner-hardening-styles';
    style.setAttribute('data-a11y-hardening-version', '2026-10-26-ea-focus-return');
    style.textContent = [
      '#shopify-pc__banner .a11y-cookie-controls {',
      '  display: grid !important;',
      '  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;',
      '  gap: 12px !important;',
      '  min-width: 0 !important;',
      '  width: 100% !important;',
      '}',
      '@media (max-width: 640px) {',
      '  #shopify-pc__banner .a11y-cookie-controls {',
      '    grid-template-columns: 1fr !important;',
      '  }',
      '',
      '  #shopify-pc__banner {',
      '    max-height: calc(100vh - 16px) !important;',
      '    overflow-y: auto !important;',
      '    overscroll-behavior: contain !important;',
      '    top: 8px !important;',
      '    bottom: auto !important;',
      '  }',
      '}',
      '@media (max-width: 400px), (max-height: 320px) {',
      '  #shopify-pc__prefs__overlay {',
      '    align-items: stretch !important;',
      '    box-sizing: border-box !important;',
      '    display: flex !important;',
      '    height: 100vh !important;',
      '    justify-content: center !important;',
      '    overflow: hidden !important;',
      '    padding: 8px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog {',
      '    box-sizing: border-box !important;',
      '    inset: auto !important;',
      '    left: auto !important;',
      '    margin: 0 !important;',
      '    max-height: calc(100vh - 16px) !important;',
      '    max-width: calc(100vw - 16px) !important;',
      '    overflow-x: hidden !important;',
      '    overflow-y: auto !important;',
      '    position: relative !important;',
      '    right: auto !important;',
      '    top: auto !important;',
      '    transform: none !important;',
      '    width: calc(100vw - 16px) !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog header,',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__intro,',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__option {',
      '    box-sizing: border-box !important;',
      '    padding-left: 16px !important;',
      '    padding-right: 16px !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog header {',
      '    padding-bottom: 12px !important;',
      '    padding-top: 12px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__header-title {',
      '    font-size: 16px !important;',
      '    letter-spacing: 0 !important;',
      '    line-height: 1.2 !important;',
      '    margin-bottom: 8px !important;',
      '    max-width: calc(100% - 48px) !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__header-close {',
      '    height: 44px !important;',
      '    min-height: 44px !important;',
      '    position: absolute !important;',
      '    right: 12px !important;',
      '    top: 12px !important;',
      '    width: 44px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs #shopify-pc__prefs__header-close {',
      '    height: 44px !important;',
      '    min-height: 44px !important;',
      '    min-width: 44px !important;',
      '    width: 44px !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions {',
      '    display: grid !important;',
      '    gap: 6px !important;',
      '    grid-template-columns: 1fr !important;',
      '    margin: 0 !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__header-actions button {',
      '    margin: 0 !important;',
      '    min-height: 44px !important;',
      '    width: 100% !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog .shopify-pc__prefs__option p {',
      '    box-sizing: border-box !important;',
      '    margin-left: 36px !important;',
      '    max-width: calc(100% - 36px) !important;',
      '    width: auto !important;',
      '  }',
      '',
      '  #shopify-pc__prefs__dialog * {',
      '    max-width: 100% !important;',
      '  }',
      '',
      '  body.a11y-cookie-ui-open #usableNetAssistive,',
      '  body.a11y-cookie-ui-open #usntA42Toggle,',
      '  body.a11y-cookie-ui-open #usntA42Link,',
      '  body.a11y-cookie-ui-open .okeLoyalty--floatingWidget,',
      '  body.a11y-cookie-ui-open .c-launchBubble,',
      '  body.a11y-cookie-ui-open .c-launchBubble-button {',
      '    opacity: 0 !important;',
      '    pointer-events: none !important;',
      '    visibility: hidden !important;',
      '  }',
      '}'
    ].join('\n');
    if (!style.parentNode) {
      document.head.appendChild(style);
    }
  }

  function headingCandidates(banner) {
    return Array.prototype.slice.call(
      banner.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, [role="heading"], #shopify-pc__banner__body-title, .shopify-pc__banner__body-title'
      )
    ).filter(function (heading) {
      return /^cookie consent$/i.test(cleanText(heading.textContent));
    });
  }

  function ensureBannerHeading(banner) {
    var headings = headingCandidates(banner);
    var visibleHeading = headings.filter(function (heading) {
      return !isVisuallyHidden(heading);
    })[0];

    if (!visibleHeading) {
      visibleHeading = headings[0];
    }

    if (!visibleHeading) {
      visibleHeading = document.createElement('h2');
      visibleHeading.className = 'sr-only';
      visibleHeading.textContent = 'Cookie consent';
      visibleHeading.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      banner.insertBefore(visibleHeading, banner.firstChild);
    }

    headings.forEach(function (heading) {
      if (heading !== visibleHeading) {
        heading.remove();
      }
    });

    if (!/^H[1-6]$/i.test(visibleHeading.tagName) && !visibleHeading.getAttribute('role')) {
      visibleHeading.setAttribute('role', 'heading');
      visibleHeading.setAttribute('aria-level', '2');
    }

    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('aria-labelledby', ensureId(visibleHeading, 'cookie-banner-heading'));
    banner.removeAttribute('aria-label');

    var description = banner.querySelector('.shopify-pc__banner__body p, p');
    if (description) {
      banner.setAttribute('aria-describedby', ensureId(description, 'cookie-banner-desc'));
    }
  }

  function looksLikeCookieButtonGroup(element) {
    var text = lowerText(element.textContent);
    var nestedText = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).map(function (child) {
      return [
        child.id,
        child.className,
        child.getAttribute('aria-label'),
        child.textContent
      ].join(' ');
    }).join(' ');
    var signature = lowerText(text + ' ' + nestedText);

    return signature.indexOf('accept') !== -1 &&
      signature.indexOf('decline') !== -1 &&
      (signature.indexOf('cookie preferences') !== -1 ||
        signature.indexOf('manage preferences') !== -1);
  }

  function hasNestedCookieControls(element) {
    var nestedInteractive = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).filter(function (child) {
      return child !== element;
    });

    if (nestedInteractive.length < 2) return false;
    return looksLikeCookieButtonGroup(element);
  }

  function legacyLooksLikeCookieButtonGroup(element) {
    var text = lowerText(element.textContent);
    return text.indexOf('cookie preferences') !== -1 &&
      text.indexOf('accept') !== -1 &&
      text.indexOf('decline') !== -1;
  }

  function copySafeAttributes(from, to) {
    Array.prototype.slice.call(from.attributes).forEach(function (attr) {
      if (/^(class|role|tabindex|type|name|value|disabled|aria-label|aria-labelledby|aria-pressed|aria-expanded|aria-haspopup)$/i.test(attr.name)) {
        return;
      }
      to.setAttribute(attr.name, attr.value);
    });
  }

  function replaceWithNeutralGroup(element) {
    var replacement = document.createElement('div');
    copySafeAttributes(element, replacement);
    replacement.className = 'a11y-cookie-controls';
    replacement.setAttribute('data-a11y-original-class', element.getAttribute('class') || '');
    while (element.firstChild) {
      replacement.appendChild(element.firstChild);
    }
    element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function neutralizeInvalidButtonGroup(element) {
    if (!element || (!hasNestedCookieControls(element) && !legacyLooksLikeCookieButtonGroup(element))) return null;

    var nestedInteractive = Array.prototype.slice.call(element.querySelectorAll(INTERACTIVE_SELECTOR)).filter(function (child) {
      return child !== element;
    });
    if (nestedInteractive.length < 2) return element;

    if (element.tagName === 'BUTTON' || /\bshopify-pc__banner__btns\b/i.test(element.className || '')) {
      return replaceWithNeutralGroup(element);
    }

    element.removeAttribute('role');
    element.removeAttribute('tabindex');
    element.removeAttribute('aria-label');
    element.removeAttribute('aria-labelledby');
    return element;
  }

  function removeInvalidButtonGroups(root) {
    Array.prototype.slice.call(root.querySelectorAll('button, [role="button"]')).forEach(function (element) {
      neutralizeInvalidButtonGroup(element);
    });
  }

  function labelCookieControls(root) {
    Array.prototype.slice.call(root.querySelectorAll('button, [role="button"], a')).forEach(function (control) {
      if (!isVisible(control)) return;
      if (hasNestedCookieControls(control)) return;
      var signature = lowerText([
        control.id,
        control.className,
        control.getAttribute('aria-label'),
        control.textContent
      ].join(' '));

      if (/manage|preferences/.test(signature)) {
        control.setAttribute('aria-label', 'Cookie preferences');
      } else if (/accept|allow|agree/.test(signature)) {
        control.setAttribute('aria-label', 'Accept cookies');
      } else if (/decline|reject|deny/.test(signature)) {
        control.setAttribute('aria-label', 'Decline cookies');
      }
    });
  }

  function ensureRequiredNote(root) {
    var existing = document.getElementById('shopify-pc-a11y-required-note');
    if (existing) return existing;

    var note = document.createElement('span');
    note.id = 'shopify-pc-a11y-required-note';
    note.className = 'sr-only';
    note.textContent = 'Required cookies, always active';
    note.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
    root.appendChild(note);
    return note;
  }

  function appendDescribedBy(element, id) {
    var current = cleanText(element.getAttribute('aria-describedby'));
    var parts = current ? current.split(/\s+/) : [];
    if (parts.indexOf(id) === -1) {
      parts.push(id);
      element.setAttribute('aria-describedby', parts.join(' '));
    }
  }

  function fixRequiredState() {
    var prefs = document.getElementById('shopify-pc__prefs');
    if (!prefs) return;

    var note = ensureRequiredNote(prefs);
    Array.prototype.slice.call(prefs.querySelectorAll('*')).forEach(function (element) {
      var text = lowerText(element.textContent);
      if (text === 'required' || text === 'always active') {
        element.setAttribute('aria-label', 'Required cookies, always active');
        var owner = element.closest('button, [role="switch"], [role="checkbox"], label, input');
        if (owner) {
          owner.setAttribute('aria-disabled', 'true');
          appendDescribedBy(owner, note.id);
        }
      }
    });

    Array.prototype.slice.call(prefs.querySelectorAll('[disabled], [aria-disabled="true"]')).forEach(function (control) {
      appendDescribedBy(control, note.id);
    });
  }

  function isCookieSurfaceVisible() {
    return isVisible(getBanner()) || isVisible(document.getElementById('shopify-pc__prefs')) ||
      isVisible(document.getElementById('shopify-pc__prefs__dialog'));
  }

  function isCookieControl(element) {
    return element && element.closest && element.closest(BANNER_SELECTORS + ', #shopify-pc__prefs, #shopify-pc__prefs__dialog');
  }

  // Shopify's privacy banner parks focus on this hidden, empty element when the
  // banner or the preferences dialog closes. It is not a meaningful focus position.
  var SHOPIFY_FOCUS_SINK_ID = 'shopify-pc__banner__focus-target';

  function isShopifyFocusSink(element) {
    return !!element && element.id === SHOPIFY_FOCUS_SINK_ID;
  }

  function isMeaningfulFocusTarget(element) {
    return !!element && element !== document.body && element !== document.documentElement &&
      element.isConnected && !isShopifyFocusSink(element) && !isCookieControl(element) &&
      isVisible(element) && !element.closest('[inert]');
  }

  // UsableNet (MELIN01AV-99): after the cookie UI closes, focus must land on the
  // Enable Accessibility link, unless the visitor opened the UI from a specific
  // control (for example the footer "Cookie preferences" button).
  function getCookieReturnTarget(preferred) {
    if (isMeaningfulFocusTarget(preferred)) return preferred;
    var enableAccessibility = document.getElementById('usntA42Link');
    if (enableAccessibility && isVisible(enableAccessibility)) return enableAccessibility;
    var main = document.getElementById('MainContent');
    return main && isVisible(main) ? main : null;
  }

  var lastOutsideFocus = document.activeElement;
  var cookieReturnTarget = null;
  var lastCookieReturnTarget = null;
  var cookieSurfaceWasVisible = false;

  document.addEventListener('focusin', function (event) {
    if (isShopifyFocusSink(event.target)) {
      // Shopify can move focus to its sink after our close handling has run.
      var sink = event.target;
      window.setTimeout(function () {
        if (document.activeElement !== sink || isCookieSurfaceVisible()) return;
        syncCookieSurfaceState();
        if (document.activeElement !== sink) return;
        var target = getCookieReturnTarget(lastCookieReturnTarget);
        if (target) target.focus({ preventScroll: true });
      }, 0);
      return;
    }
    if (isCookieControl(event.target)) {
      if (!cookieSurfaceWasVisible) cookieReturnTarget = lastOutsideFocus;
      cookieSurfaceWasVisible = true;
    } else {
      lastOutsideFocus = event.target;
    }
  }, true);

  document.addEventListener('focusout', function (event) {
    if (isCookieControl(event.target) || event.relatedTarget) return;
    // A blank-area click can move focus to body without a following focusin.
    // Wait for a possible cookie focusin before discarding the real opener.
    Promise.resolve().then(function () {
      var active = document.activeElement;
      if (active === document.body || active === document.documentElement) {
        lastOutsideFocus = active;
      }
    });
  }, true);

  function syncCookieSurfaceState() {
    var visible = isCookieSurfaceVisible();
    if (document.body) document.body.classList.toggle('a11y-cookie-ui-open', visible);
    if (visible && !cookieSurfaceWasVisible) cookieReturnTarget = lastOutsideFocus;
    if (cookieSurfaceWasVisible && !visible) {
      var active = document.activeElement;
      var needsReturn = !active || active === document.body || active === document.documentElement ||
        !active.isConnected || isCookieControl(active) || isShopifyFocusSink(active);
      var target = getCookieReturnTarget(cookieReturnTarget);
      lastCookieReturnTarget = target;
      cookieReturnTarget = null;
      cookieSurfaceWasVisible = false;
      if (needsReturn) {
        if (!target || target === document.body || target === document.documentElement ||
            !isVisible(target) || target.closest('[inert]')) {
          target = document.getElementById('MainContent');
        }
        if (target && isVisible(target)) target.focus({ preventScroll: true });
      }
    }
    cookieSurfaceWasVisible = visible;
  }

  function hardenCookieBanner() {
    var banner = getBanner();
    if (!banner) return;

    ensureBannerHeading(banner);
    removeInvalidButtonGroups(banner);
    labelCookieControls(banner);
  }

  var scheduled = false;
  function scheduleHardening() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      installHardeningStyles();
      ensureAssistiveLandmarks();
      hardenCookieBanner();
      fixRequiredState();
      syncCookieSurfaceState();
    }, 25);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHardening);
  } else {
    scheduleHardening();
  }

  window.setInterval(scheduleHardening, 250);

  var observer = new MutationObserver(scheduleHardening);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'role', 'aria-label', 'aria-labelledby', 'tabindex']
  });
})();
